import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP } from "./../constants";
import { LocalStorageService } from 'angular-2-local-storage';

@Injectable()
export class LoginService {
  apiEndpoint = APP.ApiEndpoint;

  constructor(
    private _LocalStorageService: LocalStorageService,
    private http: HttpClient
  ) { }

  public Login(data: any, callback) {
    const url = `${this.apiEndpoint}/api/auth/login/`;
    const self = this;
    return this.http.post(url, data).subscribe(
      result => {
        callback(result);
      }
    )
  }
}
